import React from 'react';
import { StatusBadge } from '@growthaxl/web-foundation';
import { ESASparkIcon } from '../panel/ESASparkIcon';

export interface AttentionWidgetProps {
  hitlCount: number;
  activeTaskCount: number;
  onClick: () => void;
  className?: string;
}

/**
 * Floating attention trigger shown when ESA panel is closed and HITL items
 * are pending. Uses the ESA circular sparkle as the button face and a
 * `bg-error` badge for the count — both from the foundation design system.
 */
export function AttentionWidget({
  hitlCount,
  activeTaskCount,
  onClick,
  className,
}: AttentionWidgetProps): React.ReactElement | null {
  const total = hitlCount + activeTaskCount;
  if (total === 0) return null;

  return (
    <button
      aria-label={`${total} pending item${total !== 1 ? 's' : ''}`}
      onClick={onClick}
      className={`relative border-none cursor-pointer p-0 bg-transparent ${className ?? ''}`}
    >
      <ESASparkIcon size={40} radius={20} />
      <span className="absolute -top-1 -right-1">
        <StatusBadge variant="error" styleMode="filled" size="sm" shape="pill">
          {total > 99 ? '99+' : total}
        </StatusBadge>
      </span>
    </button>
  );
}
